import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-sm md:text-md mt-2 block" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["id", "disabled"]
const _hoisted_5 = ["id", "innerHTML"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "relative z-50" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]

import { onMounted, ref, computed } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";
import { ContainerResponse } from "@/models/dtos";
import { Profile } from "@/models/Profile";
import { MainContainer } from "@/models/MainContainer";
import MxsGdpr from "@/features/agreements/components/MxsGdpr.vue";
import CustomerGdpr from "@/features/agreements/components/CustomerGdpr.vue";
import Modal from "@/features/shared/components/ui/Modal.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputCheckbox2',
  props: {
  model: {
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  renderModal: {
    required: false,
    type: Boolean,
    default: true,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const store = useStore();
const props = __props;
let model = ref(props.model);
const showModal = ref(false);
const modalContent = ref("");
const toggleModal = () => {
  showModal.value = !showModal.value;
};
const profile = ref<Profile>();

// Recruitment-agency recipient for the current ad, read from the position
// metadata that PositionApplyView loads into the formbuilder store. Empty
// unless the ad discloses to a named client company. ANSKNI-100.
const recipientCompany = computed(() => {
  const properties =
    store.getters["formbuilder/form"]?.metadata?.properties ?? [];
  const mode = properties.find(
    (p: any) => p.key === "/position/recipientMode"
  )?.data;
  if (mode !== "client") return "";
  return (
    properties.find((p: any) => p.key === "/position/recipientCompany")?.data ??
    ""
  );
});

function test(e: any) {}
function customChange(event: any) {
  emit("change", model.value);
  //
}

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};

onMounted(() => {
  if (model.value.label.includes("term01")) {
    const el = document.getElementById("term01");
    if (el !== null) {
      el.removeEventListener("click", term01);
      el.addEventListener("click", term01);
    }
  }
  if (model.value.label.includes("term02")) {
    const el = document.getElementById("term02");
    if (el !== null) {
      el.removeEventListener("click", term02);
      el.addEventListener("click", term02);
    }
  }
});
function term02() {
  modalContent.value = "gdpr-mxs";
  toggleModal();
}
function term01() {
  profile.value = new Profile(new MainContainer(store.getters.container));
  if (!profile.value.DisplayName.data) {
    profile.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
  }
  modalContent.value = "gdpr-company";
  let _id = (store.getters.container as ContainerResponse).id;

  if (!_id) {
    _id = (store.getters.publicContainer as ContainerResponse).id;
  }
  if (_id) {
    toggleModal();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.renderModal)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          "modal-title": 'Allmänna villkor',
          "show-modal": showModal.value,
          onCloseModal: toggleModal
        }, {
          default: _withCtx(() => [
            (modalContent.value === 'gdpr-mxs')
              ? (_openBlock(), _createBlock(MxsGdpr, { key: 0 }))
              : _createCommentVNode("", true),
            (modalContent.value === 'gdpr-company')
              ? (_openBlock(), _createBlock(CustomerGdpr, {
                  key: 1,
                  company: profile.value,
                  "recipient-company": recipientCompany.value
                }, null, 8, ["company", "recipient-company"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show-modal"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: __props.id,
        "data-dashlane-label": "true"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "disabled:bg-gray-1 disabled:hover:text-gray-1 disabled:text-text-gray-1 disabled:cursor-not-allowed disabled:border-gray-1",
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).data) = $event)),
            onChange: customChange,
            id: __props.id,
            disabled: props.disabled ? true : null
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, _unref(model).data]
          ]),
          (_unref(model).isHtml)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "px-2",
                id: 'inner-text_' + _unref(model).key,
                innerHTML: _unref(model).label
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (!_unref(model).isHtml)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "px-2",
                id: 'inner-text_' + _unref(model).key
              }, _toDisplayString(_unref(model).label), 9, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: 'icon-error_' + _unref(model).key,
            class: "hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center",
            onMouseenter: showErrorMessage,
            onMouseleave: hideErrorMessage
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
          ]))], 40, _hoisted_7)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
            id: 'outer-error_' + _unref(model).key
          }, [
            _createElementVNode("p", {
              class: "font-medium text-sm text-red-2",
              id: 'error_' + _unref(model).key
            }, null, 8, _hoisted_10)
          ], 8, _hoisted_9)
        ], 512), [
          [_vShow, showingErrorMessage.value]
        ])
      ], 8, _hoisted_2)
    ])
  ], 64))
}
}

})